jQuery(document).ready(function () {
  Oskari.app.loadAppSetup(ajaxUrl + 'action_route=GetAppSetup', window.controlParams, function () {
    jQuery('#mapdiv').append('Unable to start');
  });
});

/*if ('serviceWorker' in navigator) {
    window.addEventListener('load', function() {
        // Service worker is resource in servlet-map
        navigator.serviceWorker.register('/hkp/xhr-prioritizer.js').then(null, function (err) {
            Oskari.log('ServiceWorker').warn(err);
        });
    });
}*/